import { getParentAuthService } from '@/components/micro-front-ends/utils/parentAuthService'
import { getTelemetryConfig } from '@/components/micro-front-ends/utils/telemetry'

export default {
  inject: {
    preventNavigationHandler: {
      type: Function,
      default: () => {}
    },
    formDialog: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      unmount: () => {},
      error: false
    }
  },
  destroyed () {
    this.unmount()
  },
  methods: {
    async mountMfe (mount, otherOptions = {}) {
      try {
        const parentAuthService = getParentAuthService(this.$shipBobStore)
        const { isMFETelementryEnabled, host } = getTelemetryConfig(this.$shipBobStore)

        this.unmount = await mount({
          $element: this.$refs.mounter,
          hostStore: this.$shipBobStore,
          hostRouter: this.$router,
          hostPath: this.$route.fullPath,
          parentAuthService,
          isTelemetryEnabled: isMFETelementryEnabled,
          host,
          preventNavigationHandler: this.preventNavigationHandler,
          formDialog: this.formDialog,
          standAlone: false,
          ...otherOptions
        })
      } catch (e) {
        console.error('Error calling mount of mfe', e)
        this.error = true
      }
    }
  }
}
